export default class WebUnsupportedError extends Error {
    constructor() {
        super("`expo-dev-launcher` isn't supported on Expo Web.");
    }
}
//# sourceMappingURL=WebUnsupportedError.js.map